var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptDiscountBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.5H4.5C2.25 1.5 1.5 2.8425 1.5 4.5V5.25V15.75C1.5 16.3725 2.205 16.725 2.7 16.35L3.9825 15.39C4.2825 15.165 4.7025 15.195 4.9725 15.465L6.2175 16.7175C6.51 17.01 6.99 17.01 7.2825 16.7175L8.5425 15.4575C8.805 15.195 9.225 15.165 9.5175 15.39L10.8 16.35C11.295 16.7175 12 16.365 12 15.75V3C12 2.175 12.675 1.5 13.5 1.5H5.25ZM4.9275 6.0225C5.34 6.0225 5.6775 6.36 5.6775 6.7725C5.6775 7.185 5.34 7.5225 4.9275 7.5225C4.515 7.5225 4.1775 7.185 4.1775 6.7725C4.1775 6.36 4.515 6.0225 4.9275 6.0225ZM8.5725 10.56C8.1525 10.56 7.8225 10.2225 7.8225 9.81C7.8225 9.3975 8.16 9.06 8.5725 9.06C8.985 9.06 9.3225 9.3975 9.3225 9.81C9.3225 10.2225 8.985 10.56 8.5725 10.56ZM9.195 6.6L5.1 10.695C4.9875 10.8075 4.845 10.86 4.7025 10.86C4.56 10.86 4.4175 10.8075 4.305 10.695C4.0875 10.4775 4.0875 10.1175 4.305 9.9L8.4 5.805C8.6175 5.5875 8.9775 5.5875 9.195 5.805C9.4125 6.0225 9.4125 6.3825 9.195 6.6Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5075 1.5V2.625C14.0025 2.625 14.475 2.8275 14.82 3.165C15.18 3.5325 15.375 4.005 15.375 4.5V6.315C15.375 6.87 15.1275 7.125 14.565 7.125H13.125V3.0075C13.125 2.7975 13.2975 2.625 13.5075 2.625V1.5ZM13.5075 1.5C12.675 1.5 12 2.175 12 3.0075V8.25H14.565C15.75 8.25 16.5 7.5 16.5 6.315V4.5C16.5 3.675 16.1625 2.925 15.6225 2.3775C15.075 1.8375 14.3325 1.5075 13.5075 1.5C13.515 1.5 13.5075 1.5 13.5075 1.5Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptDiscountBlack);
export default __webpack_public_path__ + "static/media/receipt-discount-black.049206b6e56610b94102527d99feeccd.svg";
export { ForwardRef as ReactComponent };